const meta = {
  monitors: 'Monitors',
  notifications: 'Notifications',
  'muting-rules': 'Muting rules',
  metrics: 'Alert metrics',
  troubleshooting: 'Troubleshooting',
};

export default meta;
